// extracted by mini-css-extract-plugin
export var content = "_dx-3";
export var list = "_dx-4";
export var settingsContent = "_dx-7";
export var settingsPanel = "_dx-8";
export var state = "_dx-6";
export var triggerBadge = "_dx-2";
export var triggerButton = "_dx-1";
export var triggerShell = "_dx-0";
export var unreadDot = "_dx-5";